import { getSpotConfig } from '@host-panel/request/config';
import { MODERATION_FILTERS_CONFIGS, MODERATION_NS } from './moderationFiltersConstants';

export async function getModerationFiltersConfigs(spotId: string) {
  const keys = MODERATION_FILTERS_CONFIGS.map(key => `${MODERATION_NS}.${key}`);

  return await getSpotConfig(spotId, keys);
}
